'use client';

import Link from 'next/link';
import parse from 'html-react-parser';
import axios from '@/lib/axios';
import { useEffect, useState } from 'react';

type GeneralSettingItem = {
  value: string;
  [key: string]: any;
};

export default function AboutPage() {
  const [generalsSetting, setGeneralsSetting] = useState<
    GeneralSettingItem[] | null
  >(null);

  useEffect(() => {
    async function fetchSettings() {
      try {
        const response = await axios('/api/v2/general-settings');
        setGeneralsSetting(response.data.data);
      } catch (error) {
        console.error('Failed to fetch general settings:', error);
      }
    }

    fetchSettings();
  }, []);

  // Function to clean HTML by removing Office-specific tags
  const renderCleanHtml = () => {
    if (!generalsSetting?.[15]?.value) return null;

    // Remove Office-specific tags like <o:p> and </o:p>
    const cleanHtml = generalsSetting[15].value.replace(/<\/?o:[a-z]+>/gi, '');
    return parse(cleanHtml);
  };

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link href="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <div className="about-section">
        <div className="container">{renderCleanHtml()}</div>
      </div>
    </>
  );
}
